<template>
    <div class="container">   
        <div class="header">
            <div class="image-box">
                <van-swipe :autoplay="3000" class="swipe-box">
                    <van-swipe-item v-for="(image, index) in swipeArray" :key="index">
                        <van-image 
                            class="swipe-itme"
                            lazy-load
                            :src="image"
                        />
                    </van-swipe-item>
                </van-swipe>
            </div>
            <div class="header-line"></div>
        </div>

        <ul class="body" >

            <li class="reder-item reder-item-tab-box">
                <van-tabs 
                    :border="false"
                    color="#4282FF"
                    title-active-color="#4282FF"
                    title-inactive-color="#8E969E"
                    v-model="tabActive"
                    :lazy-render="false"
                    :sticky="!true"
                >
                    <!-- @change="changeTab" -->
                    <van-tab 
                        v-for="(item,index) in tabList" 
                        :title="item.name"
                        :key="index"
                    >
                        <!-- 内容 {{ index }} -->
                    </van-tab>
                </van-tabs>
            </li>

            <li class="reder-item-tab-box f-c tips-box">
                <i v-if="true" class="iconhebei icondui theme-color-font"></i>
                <i v-else class="iconhebei iconweixuanzhong "></i>
                <span class="font g-b-500" style="color:#4282ff;" >有活动立即通知我</span>
            </li>

            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
            >
                <li 
                    v-touch:tap="goToDetail(item)"
                    v-for="(item, index) in getShowList" :key="index"
                    class="reder-item f-s-b"
                >

                    <van-image 
                        class="left-image-box"
                        lazy-load
                        fit="cover"
                        :src="tokenImage(item.image)"
                    />
                    <div class="right-info-box f-s-b">
                        <div class="name " :class="item.quota>0 ? 'ellipsis name-active':'ellipsis2'">{{item.title}}</div>
                        <div class="year">{{item.date}}</div>
                        <div class="good-at">主讲人: {{item.name}}</div>
                        <div class="good-at">报名条件: {{item.condition}}</div>
                        <div class="level"  v-if="item.quota>0">
                            <span class="quota">报名人数</span>
                            <!-- <span class="g-yellow-color g-b-500">{{item.quota}}</span> -->
                            <span class="g-yellow-color g-b-500">{{item.count}}</span>
                        </div>
                    </div>

                </li>
            </van-list>   

        </ul>

    </div>
</template>

<script>
    import { 
        Swipe, 
        SwipeItem, 
        Tab, 
        Tabs,
        List,
    } from 'vant';
    import util from '@util';
    import { 
        getActivityTypeUrl,
        getActivityListUrl, 
    } from '@ticketUrl';
    import {
        tokenImage
    } from '@js/url.js';
    export default {
        data() {
            return {
                tabActive: 0,
                tabList: [
                    {
                        name: '宣教活动',
                        id: 0,
                    },
                    {
                        name: '文创活动',
                        id: 1,
                    },
                    {
                        name: '公益活动',
                        id: 2,
                    },
                ],
                swipeArray: [
                    require('@image/home/34.png'),
                ],
                activityList:[
                    {   
                        image: require('@image/home/wanglili.png'),
                        title: '2019亲子活动游',
                        date: '11月30日星期日  09:00-11:00',
                        name: '刘某',
                        condition: '5-7岁',
                        quota: 0,
                    },
                    {   
                        image: require('@image/home/342.png'),
                        title: '小小科学家',
                        date: '11月30日星期日  09:00-11:00',
                        name: '刘某',
                        condition: '5-7岁',
                        quota: 222,
                    },
                    {   
                        image: require('@image/home/243242.png'),
                        title: '2019亲子活动游',
                        date: '11月30日星期日  09:00-11:00',
                        name: '刘某',
                        condition: '5-7岁',
                        quota: 2,
                    }
                ],

                // list: [],
                loading: false,
                finished: false,
            }
        },
        created() {
            this.activityList = [];
            this.getTypeData();
        },
        methods: {
            tokenImage,
            getTypeData(){
                this.$http.get(getActivityTypeUrl)
                .then(res =>{
                    this.tabList = [];
                    const {
                        data:tempArray
                    } = res;
                    this.tabList = tempArray;
                    this.tabList.unshift({
                        name:'全部',
                        id:"0",
                    })
                    this.getListData();
                })
            },

            getListData(){
                this.$http.get(getActivityListUrl, {params:{days: -100}})
                .then(res =>{
                    const {
                        data:tempArray
                    } = res;
                    this.activityList = [];
                    tempArray.map(item=>{
                        this.activityList.push({
                            image: item.image,
                            title: item.name,
                            date: util.formatTime(new Date(item.startTime),'时分秒') + " - " + util.formatTime(new Date(item.endTime),'时分秒'),
                            name: item.speaker,
                            condition: (item.minAge > 0 && item.maxAge > 0) ? `${item.minAge} - ${item.maxAge}岁`:'无条件限制' ,
                            quota: item.surplusQuota > 0 ? item.surplusQuota : 0,
                            count: item.count,
                            rawData: item,
                        })
                    })
                    this.finished = true;
                })
            },

            goToDetail(item){
                return ()=>{
                    const {
                        id:activityId,
                    } = item.rawData;
                    this.$router.push({name:'activityDetail',query:{activityId}});
                }
            },

            onLoad() {
                return
                // 异步更新数据
                // setTimeout 仅做示例，真实场景中一般为 ajax 请求
                setTimeout(() => {
                    // this.randomList();
                    this.getListData();
                    // 加载状态结束
                    this.loading = false;
                    // 数据全部加载完成
                    // if (this.list.length >= 60) {
                    //     this.finished = true;
                    // }
                    // if (this.activityList.length >= 60) {
                    //     this.finished = true;
                    // }
                }, 1000);
            },
            // changeTab(index){
            //     // this.activityList = [];
            //     // this.randomList();
            // },
            randomList(){
                var activityList = [
                        {   
                            image: require('@image/home/wanglili.png'),
                            title: '2019亲子活动游',
                            date: '11月30日星期日  09:00-11:00',
                            name: '刘某',
                            condition: '5-7岁',
                            quota: 0,
                        },
                        {   
                            image: require('@image/home/342.png'),
                            title: '小小科学家',
                            date: '11月30日星期日  09:00-11:00',
                            name: '刘某',
                            condition: '5-7岁',
                            quota: 222,
                        },
                        {   
                            image: require('@image/home/243242.png'),
                            title: '2019亲子活动游',
                            date: '11月30日星期日  09:00-11:00',
                            name: '刘某',
                            condition: '5-7岁',
                            quota: 2,
                        }
                    ]
                    for (let index = 0; index < (parseInt(Math.random()*10) + 20); index++) {
                        var tempIndex = parseInt(Math.random()*3);
                        this.activityList.push(activityList[tempIndex]);
                    }
            },
        },
        computed: {
            getShowList(){
                let id = this.tabList[this.tabActive].id;
                if(id === "0"){
                    return this.activityList;
                }else{
                    return this.activityList.filter(item=>{
                        if(item.rawData.typeId === id){
                            return item
                        }
                    })
                }
            }
        },
        components: {
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [List.name]: List,
        }
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";
    .container{
        position: relative;
        .header{
            .swipe-itme{
                width: 100%;
            }
            .image-box{
                height: 185px;
                line-height: 185px;
            }
            .header-line{
                height:47px;
                background:linear-gradient(270deg,rgba(32,107,148,1) 0%,rgba(14,57,91,1) 100%);
            }
        }
        .body{
            position: absolute;
            left: 0;
            right: 0;
            top: 197px;
            
            @paddingSize:7px;
            padding: @paddingSize;
            box-sizing: border-box;
            .reder-item{
                overflow: hidden;
                margin-bottom: @paddingSize;
                padding: 17px 13px;
                background:rgba(255,255,255,1);
                box-shadow:0px 1px 8px 0px rgba(212,206,218,0.5);
                border-radius:5px;
                // @size:100px;
                @size:114px;
                .left-image-box{
                    height: @size;
                    // width: 140px;
                    width: 162px;
                    border-radius:4px;
                    overflow: hidden;
                }
                .right-info-box{
                    flex-direction: column;
                    align-items: flex-start;
                    // width: ~"calc(100% - 140px)";
                    width: ~"calc(100% - 162px)";
                    height: @size;
                    position: relative;
                    padding-left: 13px;
                    box-sizing: border-box;
                    font-size: 12px;
                    .name{
                        width: 100%;
                        font-size:16px;
                        font-weight:500;
                        color:rgba(53,58,62,1);
                    }
                    .name-active{
                        width: ~'calc(100% - 85px)';
                    }
                    .year,.good-at{
                        // height:17px;
                        font-size:12px;
                        font-weight:500;
                        color:rgba(152,156,165,1);
                    }
                    .level{
                        color:rgba(152,156,165,1);
                        font-weight:500;
                        font-size: 14px;
                        position: absolute;
                        right: 0;
                        top: 0;
                        .quota{
                            margin-right: 5px;
                        }
                    }
                    .leve-up{
                        color: #D4AB35;
                    }
                    .leve-middle{
                        color: #2FB147;
                    }
                    .leve-below{
                        color: #4282FF;
                    }
                }
                &:last-child{
                    margin: 0;
                }
            }
            .reder-item-tab-box{
                padding: 0;
                height: 55px;
                margin: 0;
            }
            .tips-box{
                padding-left: 13px;
                justify-content: flex-start;
                color: #8E969E;
                .font{
                    font-size: 14px;
                    margin-left: 5px;
                }
            }
        }
    }
</style>